import { useAuthenticationContext } from '../../../../../../context/Authentication/AuthenticationContext';
import { ESkatActions } from './ESkatActions';
import { ESkatLogged } from './ESkatLogged';

export const ESkatGroup = () => {
  const { isAuthenticated } = useAuthenticationContext();

  if (!isAuthenticated) {
    return <ESkatActions />;
  }

  return <ESkatLogged />;
};
